<template>
  <div class="main">
    <Header
      :logo-white="false"
      :button="true"
      :background="true"
    />
    <div class="flex-column flex-grid--full">
      <BlogHeader
        blogTitle="Regels en voorwaarden iSalu"
        blogSubTitle="We bellen je graag als je nog vragen hebt"
        AssetHeader= "/img/webp/bg-home-full.webp"
        height= "475px"
      />
      <div class="flex-grid justify-center">
        <div class="col col-2 content">
          <h2>          
            Artikel 1. Definities
          </h2>
          <div>
            <ul class="unstyled">              
              <li>iSalu: iSalu B.V.</li>
              <li>Gebruiker: degene die zich op de website heeft geregistreerd.</li>
              <li>Registratie: aanmelding van de gebruiker op de website door middel van het invullen van het registratieformulier op de website.</li>
              <li>Bod: elk door gebruiker geboden bedrag op een onroerende zaak.</li>
              <li>Verkoper: degene in wiens/wier opdracht de onroerende zaak wordt verkocht.</li>
              <li>Koopovereenkomst: de koopovereenkomst tussen koper en verkoper.</li>
              <li>Koopprijs: het bedrag van het hoogste (toegewezen) bod verhoogd met de vergoeding van de door verkoper gemaakte verkoopkosten.</li>
              <li>Koop: de overeenkomst waarbij de een zich verbindt een zaak te geven en de ander om daarvoor een prijs in geld te betalen.</li>
            </ul>
          </div>
        </div>
        <div class="col col-2 content">
          <h2>          
            Artikel 2. Toepasselijkheid
          </h2>
          <div>
            <ul class="unstyled">              
              <li>Deze regels en voorwaarden zijn van toepassing op alle door iSalu georganiseerde biedprocessen voor de onroerende zaak, alle biedingen daarop, iedere inschrijving door een Gebruiker alsmede alle daarmee verband houdende handelingen. De toepasselijkheid van door Gebruiker gehanteerde algemene en/of bijzondere voorwaarden wordt uitdrukkelijk van de hand gewezen.</li>
              <li>Wanneer deze regels en voorwaarden worden gewijzigd, dan zijn de gewijzigde voorwaarden vanaf het moment van inwerkingtreden van toepassing op de biedprocessen, inschrijvingen en alle daarmee verband houdende handelingen. </li>
              <li>Door registratie bevestigt de gebruiker akkoord te gaan met de toepasselijkheid van deze regels en voorwaarden en bevestigt hij bekend te zijn met de inhoud van deze regels en voorwaarden. Tevens bevestigt de gebruiker akkoord te gaan en bekend te zijn met de inhoud van het privacy statement.</li>
              <li>Deze regels en voorwaarden zijn van toepassing op de relatie tussen iSalu en de gebruiker alsmede op de relatie tussen gebruiker en verkoper.</li>
            </ul>
          </div>
        </div>
        <div class="col col-2 content">
          <h2>          
            Artikel 3. Werking biedingsproces
          </h2>
          <div>
            <ul class="unstyled">              
              <li>De website maakt gebruik van een transparant biedingssysteem. De gebruiker dient zich te registreren via het registratieformulier op de website. De gebruiker dient zich in te schrijven met een geldig e-mailadres en dient meerderjarig te zijn. Na registratie kan de gebruiker bieden op één of meer onroerende zaken die op de website van iSalu zijn geplaatst. </li>
              <li>Het bieden vindt plaats bij opbod. De biedingen moeten voor de eindtijd zijn uitgebracht. Deze eindtijd wordt vooraf bekend gemaakt op de website. Bij biedingen in de slotfase van de veiling, wordt de biedingen tijd verlengd. </li>
              <li>Gebruiker dient voorafgaand aan de biedingen de onroerende zaak te bezichtigen en te inspecteren. De verkoper zal tenminste één open dag houden waarop de gebruiker de woning kan bezichtigen.</li>
              <li>Ieder bod van een natuurlijk persoon die niet handelt in de uitoefening van een beroep of bedrijf, is voorwaardelijk en herroepelijk. De koop komt pas tot stand op het moment dat de schriftelijke koopovereenkomst door de verkoper en de gebruiker / koper rechtsgeldig is ondertekend. Ieder bod van een gebruiker die een rechtspersoon is dan wel een persoon  die handelt in de uitoefening van een beroep of bedrijf, is onvoorwaardelijk, onherroepelijk en zonder enig voorbehoud. </li>
              <li>Indien het biedproces is geëindigd, beslist de verkoper wiens bod wordt aanvaard. iSalu zal zich zo spoedig mogelijk hierover uitspreken en de gebruiker zal daarvan zo spoedig mogelijk in kennis worden gesteld. Voorts zal met de gebruiker zo spoedig mogelijk een koopovereenkomst worden opgesteld.  </li>
              <li>De verkoper is gerechtigd om zonder opgave van redenen biedingen niet te aanvaarden. De verkoper kan voorts besluiten de (internet)verkoop niet door te laten gaan, eerder te beëindigen, te verlengen of een nieuw biedproces te starten. Het aanbieden van de onroerende zaak middels de website van iSalu betekent niet dat de verkoper de onroerende zaak niet op een andere wijze mag verkopen of te koop mag aanbieden.  </li>
              <li>iSalu is geen partij bij de koopovereenkomst, doch bemiddelt slechts bij het tot stand brengen van de koopovereenkomst ten behoeve van de verkoper.  </li>
            </ul>
          </div>
        </div>
        <div class="col col-2 content">
          <h2>          
            Artikel 4. Organisatie 
          </h2>
          <div>
            <ul class="unstyled">              
              <li>De organisatie, voorbereiding en uitvoering van de verkoop berusten bij iSalu. iSalu heeft de bevoegdheid om voorbij te gaan aan een bod, één of meer gebruikers van de verkoop uit te sluiten, vergissingen bij biedingen en/of toewijzingen te herstellen, zonder dat de Gebruiker van deze vergissingen gebruik kan maken en/of rechten daaraan kan ontlenen en andere, naar haar oordeel, noodzakelijke maatregelen nemen.  </li>
            </ul>
          </div>
        </div>
        <div class="col col-2">
          <h2>          
            Artikel 5. Bieding 
          </h2>
          <div>
            <ul class="unstyled">     
              <li
                v-if = "this.$route.query.normalFee !== 'false'"
              > De verkoopkosten van de onroerende zaak komen, indien een koopovereenkomst tot stand komt tussen de koper en verkoper, voor rekening van de koper. De verkoopkosten bestaan uit een vast bedrag, de veilingfee. Bij het biedingsproces worden deze verkoopkosten weergegeven. De verkoopkosten betreft een bedrag inclusief BTW. Het geldbedrag van de bieding wordt dus uitgedrukt in euro’s en is inclusief de verkoopkosten. </li>
              <li>Met de bieding geeft de gebruiker aan welke (ontbindende of opschortende) voorwaarden de gebruiker van toepassing wil verklaren op de bieding. </li>
              <li>De koopprijs van de onroerende zaak, en eventueel roerende zaken en andere belastingen en kosten dienen voor de eigendomsoverdracht op de derdengeldenrekening van de notaris te worden gestort. </li>
              <li>Alle genoemde kosten, zoals notariskosten en advieskosten van hypothecaire leningen zijn slechts indicatief. Tarieven verschillen per notariaat en hypotheekverstrekker en/of hypotheekintermediair. Het is verantwoordelijkheid van bieder/koper zich te verwittigen inzake hoogte van voorgenoemde de tarieven alsmede de hoogte van de te betalen overdrachtsbelasting.</li>
            </ul>
          </div>
        </div>
        <div class="col col-2 content">
          <h2>          
            Artikel 6. Aansprakelijkheid 
          </h2>
          <div>
            <ul class="unstyled">              
              <li>De gegevens op de website zijn indicatief. Ze mogen alleen worden beschouwd als een vrijblijvende advertentie. De getoonde foto’s betreffen een momentopname, de feitelijke situatie kan anders zijn. Bij onduidelijkheid over de op de website verstrekte informatie kunt u zich wenden tot iSalu. iSalu kan, ondanks de door haar bij het samenstelling van de op haar website opgenomen verkoopdocumentatie in acht genomen zorg, de juistheid en/of volledigheid daarvan niet garanderen. </li>
              <li>iSalu sluit hierbij iedere aansprakelijkheid uit voor welke schade dan ook direct en/of indirect, op enige wijze ontstaan waaronder maar niet beperkt tot schade voortvloeiende uit het gebruik van de website van iSalu, zoals de juistheid van de op deze website gegeven informatie, het ontbreken daarvan, de actualiteit daarvan gebreken of virussen en/of soortgelijke bestanden en programma’s door het bezoek op deze website en deelname aan het biedproces. </li>
              <li>De aansprakelijkheid van iSalu is in ieder geval beperkt tot het bedrag dat wordt uitgekeerd door de beroepsaansprakelijkheidsverzekering.  </li>
            </ul>
          </div>
        </div>
        <div class="col col-2 content">
          <h2>          
            Artikel 7. Verwerking persoonsgegevens 
          </h2>
          <div>
            <ul class="unstyled">              
              <li>In het kader van haar dienstverlening verwerkt iSalu de persoonsgegevens van de gebruiker. Verwezen wordt naar de privacy statement. Door zich te registreren op de website van iSalu, wordt door de gebruiker toestemming gegeven tot verwerking van de (persoons)gegevens. </li>
            </ul>
          </div>
        </div>
        <div class="col col-2 content">
          <h2>          
            Artikel 8. Toepasselijk recht 
          </h2>
          <div>
            <ul class="unstyled">              
              <li>Op deze voorwaarden is het Nederlands recht van toepassing. De Nederlandse rechter is bij uitsluiting bevoegd om te beslissen over geschillen die voortvloeien uit deze regels en voorwaarden en/of uit de verkoop voortvloeiende geschillen. </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Header from "@/components/ComponentHeader";
import BlogHeader from "@/components/ComponentBlogHeader";
import Footer from "@/components/ComponentFooter";

export default {
  name: "AlgemeneVoorwaarden",
  components: {
    Header,
    BlogHeader,
    Footer
  },
};
</script>

<style scoped>
.content {
  margin-bottom: 64px;
}

@media screen and (min-width: 1024px) {

}


@media (min-width: 240px) and (max-width: 720px) {
  .content {
    margin-bottom: 20px;
  }
}
</style>
